import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService, LanguageService } from '@nimmsta/ng-commons-lib';

@Component({
  standalone: true,
  imports: [RouterOutlet],
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  private languageService = inject(LanguageService);
  private authService = inject(AuthService);

  constructor() {
    this.authService.loadCurrentUser().subscribe({
      complete: () => {
        this.languageService.changeLanguage(this.languageService.getPreferredLanguage());
      },
      error: () => {
        this.languageService.changeLanguage(this.languageService.getPreferredLanguage());
      },
    });
  }
}
